// Models
PJQ.models.projectParticipants.ProjectContactComment = PJQ.models.BaseModel.extend({
	idAttribute: "projectContactCommentId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants',
				value: this.options.contactId
			},
			{
				endpoint: 'comments',
				value: this.get('projectContactCommentId')
			}
		], [
			{
				parameter: 'isCompanyComments',
				value: this.options.isCompanyComments
			}
		])
	}
});

PJQ.models.projectParticipants.ProjectParticipantForView = PJQ.models.projectParticipants.ProjectParticipant.extend({
	updateStatus: function (status, callback) {
		let endpointArr = [
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants',
				value: this.id
			}
		];

		if (this.collection != null && this.collection.options.groupId > 0) {
			endpointArr.push({
				endpoint: 'groups',
				value: this.collection.options.groupId
			});
		}
		else if (this.collection != null && this.collection.options.isPerGroup) {
			endpointArr.push({
				endpoint: 'groups',
				value: parseInt(this.collection.options.groupIdList)
			});
		}

		if (this.collection != null && this.collection.options.projectMessageId > 0) {
			endpointArr.push({
				endpoint: 'messages',
				value: this.get('projectMessageContactBroadcastId')
			});
		}

		endpointArr.push({
			endpoint: 'status'
		});

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, [
				{
					parameter: "status",
					value: status
				}
			])
		}).post().done(_.bind(function (response) {
			this.set('status', status);
			callback(response);
		}, this));
	}
});

PJQ.models.projectParticipants.ProjectParticipantGroupForView = PJQ.models.projectParticipants.ProjectParticipant.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants',
				value: this.get('contactId')
			},
			{
				endpoint: 'groups',
				value: this.get('groupId')
			}
		]);
	},
	updateStatus: function (status, callback) {
		let endpointArr = [
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants',
				value: this.get('contactId')
			},
			{
				endpoint: 'groups',
				value: this.get('groupId')
			},
			{
				endpoint: 'status'
			}
		];
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, [
				{
					parameter: "status",
					value: status
				}
			])
		}).post().done(_.bind(function (response) {
			this.set('status', status);
			callback(response);
		}, this));
	}
});

PJQ.models.projectParticipants.ProjectParticipantCompanyForView = PJQ.models.projectParticipants.ProjectParticipantForView.extend({});

PJQ.models.projectParticipants.ProjectMessageForView = PJQ.models.BaseModel.extend({});

PJQ.models.projectParticipants.ProjectResponseForView = PJQ.models.BaseModel.extend({});

PJQ.models.projectParticipants.ProjectGroupForView = PJQ.models.BaseModel.extend({});

PJQ.models.projectParticipants.FilterInfo = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants'
			},
			{
				endpoint: 'views'
			},
			{
				endpoint: 'filter'
			}
		], [
			{
				parameter: 'searchFor',
				value: encodeURIComponent(this.options.searchFor ? this.options.searchFor : '')
			},
			{
				parameter: 'view',
				value: this.options.view
			},
			{
				parameter: 'projectMessageBroadcastId',
				value: this.options.projectMessageBroadcastId
			}
		])
	}
});

PJQ.models.projectParticipants.ProjectMessageViewSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'projectmessaging'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	getSettings: function (view) {
		return _.find(this.attributes.settings, _.bind(function (setting) {
			return setting.view === view;
		}, this));
	},
	parse: function (model) {
		if (model != null) {
			_.each(model.settings, function (setting) {
				if (setting.view === PJQ.constants.projectMessaging.views.COMP || setting.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
					setting.hasCustomFields = _.find(setting.columns, function (column) {
						return column.toLowerCase().indexOf('companycustomfield_') !== -1;
					}) != null;
				}
				else if (setting.view === PJQ.constants.projectMessaging.views.CONT || setting.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT
					|| setting.view === PJQ.constants.projectMessaging.views.GROUPCONT_CONT || setting.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT
					|| setting.view === PJQ.constants.projectMessaging.views.RSPCONT_CONT || setting.view === PJQ.constants.projectMessaging.views.BIDPKGS_CONT) {
					setting.hasCustomFields = _.find(setting.columns, function (column) {
						return column.toLowerCase().indexOf('contactcustomfield_') !== -1 || column.toLowerCase().indexOf('companycustomfield_') !== -1;
					}) != null;
				}
				else {
					setting.hasCustomFields = false;
				}
			}, this);
		}
		return model;
	}
});

PJQ.models.projectParticipants.ProjectMessageDeclineQuestionSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'projectmessaging'
			},
			{
				endpoint: 'declinequestion'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

//Collections
PJQ.collections.projectParticipants.ProjectParticipantsForView = PJQ.collections.BaseCollection.extend({
	beforeConstruct: function (models, options) {
		switch (options.view) {
			case PJQ.constants.projectMessaging.views.GROUPCOMP:
			case PJQ.constants.projectMessaging.views.GROUPCONT:
				this.model = PJQ.models.projectParticipants.ProjectGroupForView;
				break;
			case PJQ.constants.projectMessaging.views.MSGCONT:
				this.model = PJQ.models.projectParticipants.ProjectMessageForView;
				break;
			case PJQ.constants.projectMessaging.views.RSPCONT:
				this.model = PJQ.models.projectParticipants.ProjectResponseForView;
				break;
			case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
			case PJQ.constants.projectMessaging.views.COMP:
				this.model = PJQ.models.projectParticipants.ProjectParticipantCompanyForView;
				break;
			case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
			case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
			case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
			case PJQ.constants.projectMessaging.views.MSGCONT_CONT:
			case PJQ.constants.projectMessaging.views.COMP_CONT:
			case PJQ.constants.projectMessaging.views.CONT:
				this.model = PJQ.models.projectParticipants.ProjectParticipantForView;
				break;
			case PJQ.constants.projectMessaging.views.CONTGROUP:
				this.model = PJQ.models.projectParticipants.ProjectParticipantGroupForView;
				break;
		}
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants'
			},
			{
				endpoint: 'views'
			},
			{
				endpoint: this.options.view
			}
		], [
			{
				parameter: 'contactId',
				value: this.options.contactId
			},
			{
				parameter: 'contactCompanyId',
				value: this.options.contactCompanyId
			},
			{
				parameter: 'groupIdList',
				value: this.options.groupIdList
			},
			{
				parameter: 'projectMessageId',
				value: this.options.projectMessageId
			},
			{
				parameter: 'statusFilter',
				value: this.options.statusFilter
			},
			{
				parameter: 'isPerGroup',
				value: this.options.isPerGroup
			},
			{
				parameter: 'searchFor',
				value: encodeURIComponent(this.options.searchFor ? this.options.searchFor : '')
			},
			{
				parameter: 'withCustomFields',
				value: this.options.withCustomFields != null ? this.options.withCustomFields : false
			},
			{
				parameter: 'bidPackageId',
				value: this.options.bidPackageId
			}
		])
	}
});

PJQ.collections.projectParticipants.ProjectParticipantComments = PJQ.collections.BaseCollection.extend({
	idAttribute: 'commentId',
	model: PJQ.models.projectParticipants.ProjectContactComment,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants',
				value: this.options.isCompanyComments ? this.options.participant.get('contactCompanyId') : this.options.participant.get('contactId')
			},
			{
				endpoint: 'comments'
			}
		], [
			{
				parameter: 'isCompanyComments',
				value: this.options.isCompanyComments
			}
		])
	}
});

PJQ.collections.projectParticipants.ProjectParticipantGroups = PJQ.collections.BaseCollection.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: "projects",
				value: PJQ.app.session.project.id
			},
			{
				endpoint: "participants",
				value: this.options.contactId
			},
			{
				endpoint: "groups"
			}
		]);
	}
});
